<template>
  <div class="background-image-container">
    <ImageUploaderModal
      v-if="isImageUploaderModalShowing"
      :imageObject.sync="imageObject"
      :imageViewSize="imageViewSize"
      :onCloseModal="onCloseImageUploaderModal" />
    <div class="background-image-header">
      <div class="actions">
        <button
          type="button"
          class="btn btn-link p-0"
          @click.stop="chooseImage">
          <slot name="button-text" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUploaderModal from '@/image/ImageUploaderModal.vue';

export default {
  props: {
    image: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    ImageUploaderModal,
  },
  data() {
    return {
      imageViewSize: 'cover1280w720h',
      imageObject: null,
      isImageUploaderModalShowing: false,
    };
  },
  watch: {
    imageObject(newValue) {
      this.$emit('update:image', newValue);
      this.onCloseImageUploaderModal();
    },
  },
  methods: {
    chooseImage() {
      this.onToggleImageUploaderModal();
    },
    onCloseImageUploaderModal() {
      this.isImageUploaderModalShowing = false;
    },
    onToggleImageUploaderModal() {
      this.isImageUploaderModalShowing = !this.isImageUploaderModalShowing;
    },
    getImageSource() {
      if (this.image) {
        return this.image;
      }
      return this.defaultImage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.background-image-header {
  display: flex;
  align-items: flex-end;

  .name {
    font-weight: normal;
    color: $body-color;
    font-family: $font-family-CSPrajad;
    font-size: $font-size-base;
  }

  .actions {
    margin-left: auto;
    margin-bottom: $spacer * 0.35;
    .btn {
      &:last-child {
        padding-right: 0;
      }
    }
  }
}

</style>
